export enum CustomerTypesEnum {
  INDIVIDUAL = 'Individual',
  ENTERPRISE = 'Enterprise',
  DISTRIBUTOR = 'Distributor',
  PROMOTER = 'Promoter',
  SUPPORT = 'Support'
}
